import React, { useState } from 'react'
import CheckboxCircleControl from '../CheckboxCircleControl/CheckboxCircleControl';

interface ICycleAutoSettingField {
  title: string;
  value: boolean;
  onChange: (value) => void;
}

interface ICycleManualSettingFieldProps {
  field: ICycleAutoSettingField;
}

const CycleManualSettingField: React.FC<ICycleManualSettingFieldProps> = ({ field }) => {
  const [stateValue, setStateValue] = useState<boolean>(field.value);

  const onClick = async () => {
    setStateValue(!field.value)
    await field.onChange(!field.value)    
  }

  return (
    <CheckboxCircleControl
      key='key'
      name="mode"
      className="text-xs"
      label={field.title}
      value={String(field.value)}
      checked={stateValue}
      onChange={onClick}
    />
  )
};

export default CycleManualSettingField;